// /app/frontend/src/lib/premiosService.js
// Servicio de premios - Lee y gestiona premios via Backend API
// El backend escribe en Firestore durante POST /api/spin
// Este servicio solo lee y reclama premios a través del backend

import { userFetch } from './userFetch';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://giroexpress-ruleta-backend.onrender.com';

/**
 * Obtener premios de un usuario desde el backend
 * El backend lee Firestore via REST API y filtra is_schema/is_test
 */
export async function getUserRewards(userId) {
  try {
    const response = await userFetch(`${API_URL}/api/user/${userId}/rewards`);
    
    if (!response.ok) {
      console.error('Error fetching rewards:', response.status);
      return [];
    }

    // Lectura única del body (defensa contra ReadableStream lock)
    const raw = await response.text().catch(() => '');
    let data = null;
    if (raw) {
      try { data = JSON.parse(raw); } catch (_) { data = null; }
    }
    
    if (!data || !data.success) {
      console.error('Backend error:', data?.error);
      return [];
    }
    
    return data.rewards || [];
  } catch (error) {
    console.error('Error obteniendo premios:', error);
    return [];
  }
}

/**
 * Reclamar premio - actualiza status via Backend API
 * Para money_cop envía datos de Pago Móvil
 * Devuelve el objeto de respuesta del backend con rewardType, xpAdded, visualKey, etc.
 * Si hay error devuelve null.
 */
export async function claimReward(rewardId, userId, claimData = null) {
  try {
    const body = { userId };
    if (claimData) {
      body.claimData = claimData;
    }
    
    const response = await userFetch(`${API_URL}/api/rewards/${rewardId}/claim`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    // Leemos el body UNA sola vez como texto y parseamos.
    // Evita locks en ReadableStream cuando hay branches de error/éxito.
    const raw = await response.text().catch(() => '');
    let data = null;
    if (raw) {
      try { data = JSON.parse(raw); } catch (_) { data = null; }
    }

    if (!response.ok) {
      console.error('Error claiming reward:', data || raw);
      return null;
    }

    return data?.success ? data : null;
  } catch (error) {
    console.error('Error reclamando premio:', error);
    return null;
  }
}

export default {
  getUserRewards,
  claimReward
};
